/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_SELECTED = "SET_SELECTED";
export const RESET_SELECTED = "RESET_SELECTED";

export const CREATE_PATTERN = "CREATE_PATTERN";
export const SET_PATTERN = "SET_PATTERN";
export const RESET_PATTERN = "RESET_PATTERN";

export const GET_PATTERN_IMAGES = "GET_PATTERN_IMAGES";

export const LOAD_PATTERNMAKER_SWATCHES = "LOAD_PATTERNMAKER_SWATCHES";

export const SET_VIEWS = "SET_VIEWS";
export const SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW";
export const PREV_VIEW = "PREV_VIEW";
export const NEXT_VIEW = "NEXT_VIEW";

export const FETCH_PRODUCT_DATA = "FETCH_PRODUCT_DATA";
export const SET_SELECTED_STYLE = "SET_SELECTED_STYLE";
export const SET_ORDER_STYLES = "SET_ORDER_STYLES";
export const SET_SELECTABLE_MODELS_DATA = "SET_SELECTABLE_MODELS_DATA";

export const UPDATE_PREVIEW_IMAGE = "UPDATE_PREVIEW_IMAGE";
export const GET_RESULTING_IMAGE = "GET_RESULTING_IMAGE";

export const SET_ACTIVE_UGC_COMPONENT = "SET_ACTIVE_UGC_COMPONENT";

export const SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS = "SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS";
export const SET_HIGHLIGHT_SELECT_STICKER_INSTRUCTIONS = "SET_HIGHLIGHT_SELECT_STICKER_INSTRUCTIONS";

export const SET_IS_CREATING_ASSETS = "SET_IS_CREATING_ASSETS";

export const USE_SVG_RENDERER = "USE_SVG_RENDERER";
export const GET_SVG_RENDERER_IMAGE = "GET_SVG_RENDERER_IMAGE";

export const SET_SOURCE = "SET_SOURCE";
